import { adminAxiosInstance } from "../../common/axiosInstance"

export function updatePassword(body) {
  return adminAxiosInstance.post(`/user/update/password`, body);
}

export const updateProfileOfUsers = (uuid, body) => {
  return adminAxiosInstance.put(`/user/update/${uuid}`, body);
};
